// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getWarrantyTypesList} from '../../../../src/shared/repositories';

export const updateWarrantyTypes = () =>
    dispatch => {

        dispatch({
            type: actions.INCREASE_BUSY_COUNTER
        });

        return getWarrantyTypesList()
            .then(data => {

                dispatch({
                    type: actions.DECREASE_BUSY_COUNTER
                });

                dispatch({
                    data,
                    type: actions.UPDATE_FETCH_WARRANTY_TYPES_SUCCESS
                });

            })
            .catch(() => {

                dispatch({
                    type: actions.DECREASE_BUSY_COUNTER
                });

            });

    };




// WEBPACK FOOTER //
// ./src/reports/warranty-expiration/action-creators/fetch-warranty-types.js